import * as React from 'react';
import { Switch } from 'react-router-dom';
import { PrivateRoute } from '../Core/PrivateRoute';
import { PermissionEnum } from '../misc/api/ApiPermissionEnum';
import DocumentTitle from '../misc/components/DocumentTitle';
import { DataCorrectionListScreen } from './List/DataCorrectionListScreen';
import { DataCorrectionRequestView } from './View/DataCorrectionRequestView';
import { SearchParams } from '../Components/Query';

export const DataCorrectionListAndViewScreen = () => {
    const [analysisSetListQuery, setAnalysisSetListQuery] = React.useState<SearchParams>();

    return (
        <DocumentTitle title="Data Corrections | Vitalograph Web Portal">
            <Switch>
                <PrivateRoute path="/dcf/view/:dcfRequestId" permissions={[PermissionEnum.AccessDataCorrections]}>
                    <DataCorrectionRequestView />
                </PrivateRoute>
                <PrivateRoute path="/dcf" permissions={[PermissionEnum.AccessDataCorrections]}>
                    <DataCorrectionListScreen cachedQuery={analysisSetListQuery} setCachedQuery={setAnalysisSetListQuery} />
                </PrivateRoute>
            </Switch>
        </DocumentTitle>
    );
};
